import { Building2, Cpu, Flame, Layers, TrendingUp } from 'lucide-react';
import type { TopicDefinition } from '@/shared/surfaces/TopicCatalogTypes';

/**
 * Token Usage surface catalog. The telemetry `interactions` data has no currency
 * field, so consumption is expressed in token volume — the proxy for what AI
 * usage costs. Hard-dollar figures live in the License portfolio section below
 * the gallery.
 */
export const TOKEN_USAGE_CATALOG: TopicDefinition[] = [
    {
        id: 'spend-by-model',
        title: 'Where the tokens go',
        navLabel: 'Model Mix',
        hook: 'A few models soak up the lion’s share of consumption.',
        question: 'Which models drive the most token spend?',
        icon: Cpu,
        accent: 'indigo',
        vizKind: 'donut',
        primaryField: 'model',
        headlineMetric: 'totalTokens',
        unitLabel: 'tokens',
        lensLabel: 'model',
        lensPlural: 'models',
    },
    {
        id: 'spend-by-team',
        title: 'Which teams burn the most',
        navLabel: 'Team Spend',
        hook: 'Consumption clusters in a handful of departments.',
        question: 'How is token spend distributed across teams?',
        icon: Building2,
        accent: 'teal',
        vizKind: 'ranked-list',
        primaryField: 'user_department',
        headlineMetric: 'totalTokens',
        unitLabel: 'tokens',
        lensLabel: 'department',
        lensPlural: 'departments',
    },
    {
        id: 'spend-by-task',
        title: 'What work costs the most',
        navLabel: 'Task Breakdown',
        hook: 'Some kinds of work are far more token-hungry than others.',
        question: 'Which task categories consume the most tokens?',
        icon: Layers,
        accent: 'violet',
        vizKind: 'ranked-list',
        primaryField: 'task_category',
        headlineMetric: 'totalTokens',
        unitLabel: 'tokens',
        lensLabel: 'task category',
        lensPlural: 'task categories',
    },
    {
        id: 'spend-trend',
        title: 'Consumption over time',
        navLabel: 'Spend Trend',
        hook: 'Token spend is trending — watch the slope, not just the total.',
        question: 'How is total token consumption changing week over week?',
        icon: TrendingUp,
        accent: 'amber',
        vizKind: 'trend',
        primaryField: 'model',
        headlineMetric: 'totalTokens',
        unitLabel: 'tokens',
        lensLabel: 'model',
        lensPlural: 'models',
        timeBucket: 'week',
    },
    {
        id: 'spend-top-consumers',
        title: 'The heaviest consumers',
        navLabel: 'Top Spenders',
        hook: 'A small group accounts for an outsized slice of the bill.',
        question: 'Who consumes the most tokens?',
        icon: Flame,
        accent: 'rose',
        vizKind: 'ranked-list',
        primaryField: 'user_id',
        headlineMetric: 'totalTokens',
        unitLabel: 'tokens',
        lensLabel: 'person',
        lensPlural: 'people',
    },
];
